module.exports = __webpack_public_path__ + "static/media/correct2.f30db69f.mp3";